module.exports = __webpack_public_path__ + "img/dark-mud-decal-09.42226c47.png";